
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * SwapCalculationType enum
 */
class SwapCalculationType {
  /**
   * Initialize enum with a given value
   * @param {SwapCalculationType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof SwapCalculationType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!SwapCalculationType}
   * @param {!SwapCalculationType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SwapCalculationType)) {
      throw new TypeError('Instance of SwapCalculationType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!SwapCalculationType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!SwapCalculationType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === SwapCalculationType.BY_POINTS.value) {
      return 'BY_POINTS'
    }
    if (this.value === SwapCalculationType.BY_MONEY_BASE_CURRENCY.value) {
      return 'BY_MONEY_BASE_CURRENCY'
    }
    if (this.value === SwapCalculationType.BY_MONEY_MARGIN_CURRENCY.value) {
      return 'BY_MONEY_MARGIN_CURRENCY'
    }
    if (this.value === SwapCalculationType.BY_MONEY_PROFIT_CURRENCY.value) {
      return 'BY_MONEY_PROFIT_CURRENCY'
    }
    if (this.value === SwapCalculationType.BY_MONEY_ACCOUNT_CURRENCY.value) {
      return 'BY_MONEY_ACCOUNT_CURRENCY'
    }
    if (this.value === SwapCalculationType.BY_PERCENTAGE_CURRENT_PRICE.value) {
      return 'BY_PERCENTAGE_CURRENT_PRICE'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!SwapCalculationType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!SwapCalculationType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!SwapCalculationType} Created enum
   */
  static fromObject (other) {
    return new SwapCalculationType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
SwapCalculationType.BY_POINTS = new SwapCalculationType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
SwapCalculationType.BY_MONEY_BASE_CURRENCY = new SwapCalculationType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
SwapCalculationType.BY_MONEY_MARGIN_CURRENCY = new SwapCalculationType(0 + 2)
// noinspection PointlessArithmeticExpressionJS
SwapCalculationType.BY_MONEY_PROFIT_CURRENCY = new SwapCalculationType(0 + 3)
// noinspection PointlessArithmeticExpressionJS
SwapCalculationType.BY_MONEY_ACCOUNT_CURRENCY = new SwapCalculationType(0 + 4)
// noinspection PointlessArithmeticExpressionJS
SwapCalculationType.BY_PERCENTAGE_CURRENT_PRICE = new SwapCalculationType(0 + 5)

export { SwapCalculationType };

/**
 * Fast Binary Encoding SwapCalculationType field model
 */
class FieldModelSwapCalculationType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelSwapCalculationType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelSwapCalculationType}
   * @param {SwapCalculationType=} defaults Default value, defaults is new SwapCalculationType()
   * @returns {!SwapCalculationType} Result value
   */
  get (defaults = new SwapCalculationType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new SwapCalculationType(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelSwapCalculationType}
   * @param {!SwapCalculationType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelSwapCalculationType };
